module.exports = __webpack_public_path__ + "img/外框3.941a4747.png";